import {
  HomeOutlined,
  MenuOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { mobileBottomMenu } from '../../config/menuConfig';

const MobileBottomMenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDesktop, setIsDesktop] = useState<boolean>(window.innerWidth >= 768);
  
  useEffect(() => {
    // Pencere boyutu değiştiğinde kontrol et
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };
    
    // Event listener ekle
    window.addEventListener('resize', handleResize);
    
    // Component unmount olduğunda event listener'ı kaldır
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const getIcon = (iconName: string | undefined): React.ReactNode => {
    switch (iconName) {
      case 'HomeIcon':
        return <HomeOutlined className="text-2xl" />;
      case 'MenuIcon':
        return <MenuOutlined className="text-2xl" />;
      case 'CogIcon':
        return <SettingOutlined className="text-2xl" />;
      case 'UserIcon':
        return <UserOutlined className="text-2xl" />;
      default:
        return <HomeOutlined className="text-2xl" />;
    }
  };

  const handleNavigation = (path: string | undefined) => {
    if (path) {
      navigate(path);
    }
  };

  // Masaüstü görünümünde menüyü tamamen gizle
  if (isDesktop) {
    return null;
  }
  
  return (
    <div
      className="mobile-menu-container"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        // PWA görünümü: yarı saydam + blur arkaplan
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        background: 'rgba(255,255,255,0.85)',
        borderTop: '1px solid rgba(0,0,0,0.06)',
        zIndex: 9999,
        // Güvenli alan desteği (iPhone çentik vs.)
        paddingBottom: 'calc(10px + env(safe-area-inset-bottom))',
        paddingTop: 8,
      }}
    >
      <div
        className="grid grid-cols-3"
        style={{
          maxWidth: 600,
          margin: '0 auto',
          height: 64,
        }}
      >
        {mobileBottomMenu.map((item) => {
          const isActive = location.pathname === item.path;
          
          return (
            <button
              key={item.id}
              onClick={() => handleNavigation(item.path)}
              aria-label={item.title}
              className="group flex flex-col items-center justify-center relative select-none"
              style={{
                WebkitTapHighlightColor: 'transparent',
              }}
            >
              <div
                className="flex items-center justify-center mb-1"
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 12,
                  backgroundColor: isActive ? 'rgba(24, 119, 242, 0.12)' : 'transparent',
                  color: isActive ? '#1976d2' : '#6b7280',
                  transition: 'all 180ms ease',
                }}
              >
                {getIcon(item.icon)}
              </div>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: isActive ? 600 : 500,
                  color: isActive ? '#1976d2' : '#6b7280',
                  lineHeight: 1,
                }}
              >
                {item.title}
              </div>
              {isActive && (
                <div
                  className="absolute"
                  style={{
                    bottom: -2,
                    width: 28,
                    height: 3,
                    backgroundColor: '#1976d2',
                    borderRadius: 999,
                  }}
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileBottomMenu;